import { render, staticRenderFns } from "./tap3.vue?vue&type=template&id=98b20972&scoped=true&"
import script from "./tap3.vue?vue&type=script&lang=js&"
export * from "./tap3.vue?vue&type=script&lang=js&"
import style0 from "./tap3.vue?vue&type=style&index=0&id=98b20972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b20972",
  null
  
)

export default component.exports